import z from "zod";

export const AuditTrailSchema = z.object({
  id: z.string(),
  entityType: z.string(), // e.g., 'booking', 'user', 'invoice'
  entityId: z.string(), // ID of the entity being audited
  action: z.enum(["created", "updated", "deleted", "bookings-cleared", "viewed"]),
  memberId: z.string(),
  email: z.string(), // Denormalize for easier display
  timestamp: z.union([z.string(), z.coerce.string()]), // ISO 8601 format or Date object
  changes: z
    .array(
      z.object({
        field: z.string(),
        oldValue: z.any(),
        newValue: z.any(),
      }),
    )
    .optional(),
  metadata: z.record(z.string(), z.any()).optional(),
});

export type AuditTrail = z.infer<typeof AuditTrailSchema>;

// export interface AuditTrail {
//   id: string;
//   entityType: string; // e.g., 'booking', 'user', 'invoice'
//   entityId: string; // ID of the entity being audited
//   action: "created" | "updated" | "deleted";
//   memberId: string;
//   email: string; // Denormalize for easier display
//   timestamp: string; // ISO 8601 format
//   changes?: FieldChange[]; // Only for updates
//   metadata?: Record<string, any>; // Additional context
// }

export interface FieldChange {
  field: string;
  oldValue: any;
  newValue: any;
  displayName?: string; // Human-readable field name
}

export interface AuditTrailFilters {
  entityType?: string;
  entityId?: string;
  memberId?: string;
  action?: "created" | "updated" | "deleted" | "bookings-cleared" | "viewed";
  startDate?: string;
  endDate?: string;
}

export interface AuditTrailSort {
  field: "timestamp" | "action" | "entityType";
  order: "asc" | "desc";
}
